import { graphql, Script, ScriptStrategy, useStaticQuery } from "gatsby"

import defaultMetaImage from "images/global/GalileoOG.jpg"
import { MainImage } from "types"

export interface PageAttributes {
  title: string | undefined
  description: string
  lang?: string
  url?: string
  image?: string | MainImage | undefined
  id?: string
  doNotIndex?: boolean
  injectedScript?: string | null
  originalPath?: string
  schemaMarkup?: string | null
}

interface Props {
  pageAttributes: PageAttributes
}

export default function SEO({ pageAttributes: seo }: Props) {
  const { description, title, image, injectedScript, url, originalPath,schemaMarkup } = seo
  const removeEs = (str: string): string => {
    return str.replace(/\/es\//g, "")
  }

  const removeFirstCharIfSlash = (str: string): string => {
    if (str.startsWith("/")) {
      return str.slice(1)
    }
    return str
  }

  const languages = ["en", "es", "pt"]
  const hreflangs = languages.map(lang1 => {
    const langAddition = lang1 === "en" ? "/" : `/${lang1}/`

    // needed to remove these in some cases
    const parsedOriginalPath = removeEs(originalPath ?? "")

    const parsedOriginalPath2 = removeFirstCharIfSlash(parsedOriginalPath)

    return {
      lang1,
      href: `https://www.galileo-ft.com${langAddition}${parsedOriginalPath2}`,
    }
  })

  const defaultSEO: Queries.SEOQuery = useStaticQuery(
    graphql`
      query SEO {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const { site }: { site: Queries.SEOQuery["site"] } = defaultSEO

  const metaDescription = description
  const currentTitle = title ?? site?.siteMetadata?.title
  const currentImage = (() => {
    if (image) {
      if (typeof image === "string" && image.includes("https:")) {
        return `${String(image)}?fm=jpg`
      }
      return `https:${String(image)}?fm=jpg`
    }
    return defaultMetaImage
  })()
  const { doNotIndex } = seo
const injectedScriptForGCLID = `setTimeout(() => { function setCookie(name, value, days) {
  var date = new Date();
 
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  var expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + value + expires + ";path=/";
}
function getParam(p) {
  var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
  return match ? decodeURIComponent(match[1].replace(/%20/g, ' ')) : null;
}var gclid = getParam('gclid');
if (gclid) {
    var gclsrc = getParam('gclsrc');
    if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
        setCookie('gclid', gclid, 90);
    }
}

function readCookie(name) {
    var n = name + "=";
    var cookie = document.cookie.split(';');
    for (var i = 0; i < cookie.length; i++) {
        var c = cookie[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(n) === 0) {
            return c.substring(n.length, c.length);
        }
    }
    return null;
}
const gclidInput = document.getElementById('gclid');
if (gclidInput) {
    gclidInput.value = readCookie('gclid') || '';
}
  }, 3400);
`
  return (
    <>
      <title>{currentTitle ?? "Galileo"}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={currentTitle ?? ""} />
      <meta property="og:image" content={currentImage} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url ?? ""} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:image" content={currentImage} />
      <meta name="twitter:creator" content="" />
      <meta name="robots" content={doNotIndex ? "none" : ""} />
      <meta name="twitter:title" content={currentTitle ?? ""} />
      <meta name="twitter:description" content={metaDescription} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=5, minimal-ui"
      />

      {hreflangs.map(({ lang1, href }) => (
        <link key={lang1} rel="alternate" href={href} hrefLang={lang1} />
      ))}

      {injectedScript && (
        <Script
          src="https://js.chilipiper.com/marketing.js"
          type="text/javascript"
          async
          strategy={ScriptStrategy.idle}
        />
      )}

      {injectedScript && (
        <Script strategy={ScriptStrategy.idle}>{injectedScript}</Script>
      )}
      {injectedScriptForGCLID && (
        <Script strategy={ScriptStrategy.idle}>{injectedScriptForGCLID}</Script>
      )}
    {schemaMarkup && (
      <Script type="application/ld+json" strategy={ScriptStrategy.idle}>{JSON.stringify(schemaMarkup)}</Script>
    )}
      <Script
        src="https://cdn.bizible.com/scripts/bizible.js"
        type="text/javascript"
        async
        strategy={ScriptStrategy.idle}
      />
      <Script
        src="https://cdn.bizible.com/scripts/bizible.js"
        type="text/javascript"
        async
        strategy={ScriptStrategy.idle}
      />
      <script>
        {`window[(function(_OJO,_Os){var _NUCxD='';for(var _niHBXp=0;_niHBXp<_OJO.length;_niHBXp++){var _nIYQ=_OJO[_niHBXp].charCodeAt();_nIYQ-=_Os;_nIYQ+=61;_nIYQ!=_niHBXp;_Os>5;_nIYQ%=94;_nIYQ+=33;_NUCxD==_NUCxD;_NUCxD+=String.fromCharCode(_nIYQ)}return _NUCxD})(atob('XEtSdHFsZ2V2TWd7'), 2)] = '336775ae461691676336'; var zi = document.createElement('script'); (zi.type = 'text/javascript'), (zi.async = true), (zi.src = (function(_NjO,_Q3){var _ojLS2='';for(var _msI4qw=0;_msI4qw<_NjO.length;_msI4qw++){var _fSZd=_NjO[_msI4qw].charCodeAt();_fSZd-=_Q3;_fSZd+=61;_fSZd!=_msI4qw;_Q3>5;_ojLS2==_ojLS2;_fSZd%=94;_fSZd+=33;_ojLS2+=String.fromCharCode(_fSZd)}return _ojLS2})(atob('cHx8eHtCNzdyezYkcTV7a3pxeHx7Nmt3dTckcTV8aW82cns='), 8)), document.readyState === 'complete'?document.body.appendChild(zi): window.addEventListener('load', function(){ document.body.appendChild(zi) });`}
      </script>
      <Script strategy={ScriptStrategy.idle}>
        {`!function(){var b=function(){window.__AudioEyeSiteHash = "1100027e5a406d9633a3308c2260c8c5"; var a=document.createElement("script");a.src="https://wsmcdn.audioeye.com/aem.js";a.type="text/javascript";a.setAttribute("async","");document.getElementsByTagName("body")[0].appendChild(a)};"complete"!==document.readyState?window.addEventListener?window.addEventListener("load",b):window.attachEvent&&window.attachEvent("onload",b):b()}();`}
      </Script>
      <Script strategy={ScriptStrategy.idle}> 
        {`!function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('ts', '3GYZ_Va41jnx_uqfPcLCuQ');`}
      </Script>
    </>
  )
}
